import { render, staticRenderFns } from "./easypaisaComponent.vue?vue&type=template&id=135f505c&"
import script from "./easypaisaComponent.vue?vue&type=script&lang=js&"
export * from "./easypaisaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports